const ADESAO = Object.freeze({
	RASCUNHO: { text: 'Em rascunho', value: 'RASCUNHO' },
	EM_ELABORACAO: { text: 'Em Elaboração', value: 'EM_ELABORACAO' },
	ENVIADO_ANALISE: { text: 'Aguardando Análise', value: 'ENVIADO_ANALISE' },
	ENVIADO_ADERENTE: { text: 'Enviado', value: 'ENVIADO_ADERENTE' },
	EM_ANALISE: { text: 'Em Análise', value: 'EM_ANALISE' },
	CONCLUIDO: { text: 'Concluído', value: 'CONCLUIDO' },
	RECUSADO: { text: 'Recusada', value: 'RECUSADO' },
	ACEITO: { text: 'Aceito', value: 'ACEITO' },
	AGUARDANDO_ANUENCIA: { text: 'Aguardando', value: 'AGUARDANDO_ANUENCIA' },
	ASSINADO: { text: 'Assinado', value: 'ASSINADO' },
})

export default {
	ADESAO,
}
